export const CALENDAR_DAYS = {
  today: { id: 'today_section', key: 'today' },
  tomorrow: { id: 'tomorrow_section', key: 'tomorrow' },
  thisWeek: { id: 'thisWeek_section', key: 'thisWeek' },
  nextWeek: { id: 'nextWeek_section', key: 'nextWeek' },
};
